export const SET_COURSE_INSTANCE_DATA = 'SET_COURSE_INSTANCE_DATA'
export const SET_TOPICS_DATA = 'SET_TOPICS_DATA'
